import axios from '@/axios'
import i18n from '@/lang'
import router from '@/router'
import { Notify, Loading, QSpinnerTail } from 'quasar'
export default {
  state: {
    userToken: '',
    images: [],
    userData: {}
  },
  actions: {
    refreshToken ({ dispatch }, origin) {
      let token = window.localStorage.getItem('userToken')
      axios.post(`/platform/user/refresh/${token}?local=${origin}`)
        .then(res => {
          window.localStorage.setItem('userToken', res.data.token)
        })
        .catch(err => {
          console.log(err)
        })
    },
    login ({ commit, dispatch }, json) {
      Loading.show({ spinner: QSpinnerTail, spinnerSize: 80, spinnerColor: 'blue' })
      axios.post(`/platform/user/signin?local=${json.origin}`, {
        login: json.email,
        password: json.password
      })
        .then(res => {
          window.localStorage.setItem('userToken', res.data.token)
          axios.defaults.headers.common['Token'] = res.data.token
          commit('saveUserImages', res.data.images)
          Loading.hide()
          router.push('/')
          dispatch('getAllRooms')
        })
        .catch(() => {
          Loading.hide()
          Notify.create({
            message: i18n.t('Usuário ou senha inválidos, tente novamente por favor'),
            position: 'top'
          })
        })
    },
    firstLogin ({ commit, dispatch }, json) {
      Loading.show({ spinner: QSpinnerTail, spinnerSize: 80, spinnerColor: 'blue' })
      axios.post(`/platform/user/signin?local=${json.origin}`, {
        login: json.email,
        password: json.password
      })
        .then(res => {
          window.localStorage.setItem('userToken', res.data.token)
          axios.defaults.headers.common['Token'] = res.data.token
          commit('saveUserImages', res.data.images)
          Loading.hide()
          router.push('/')
          dispatch('sendEmailVerify', json.email)
          dispatch('getAllRooms')
        })
        .catch(() => {
          Loading.hide()
          Notify.create({
            message: i18n.t('Usuário ou senha inválidos, tente novamente por favor'),
            position: 'top'
          })
        })
    },
    recoverPassword ({ dispatch }, email) {
      Loading.show({ spinner: QSpinnerTail, spinnerSize: 80, spinnerColor: 'blue' })
      axios.post('/platform/user/public/forgotPassword/' + email, {
        content: 'Olá $user.name parece que você esqueceu sua senha, aqui está um link para você recupera-lá <a href="http://localhost:8080/sign/recoverPass/$user.token">Clique Aqui</a>',
        subject: 'Plataforma Multicargo - Recuperar sua senha'
      })
        .then(res => {
          Loading.hide()
          Notify.create({
            message: i18n.t('Um email foi enviado para sua recuperação de senha!'),
            position: 'top',
            color: 'positive'
          })
          router.push('/')
        })
        .catch(() => {
          Loading.hide()
          Notify.create({
            message: i18n.t('message.sendEmailFailed'),
            position: 'top'
          })
        })
    },
    register ({ dispatch }, json) {
      Loading.show({ spinner: QSpinnerTail, spinnerSize: 80, spinnerColor: 'blue' })
      console.log(json)
      let login = {
        email: json.email,
        password: json.password
      }
      return new Promise((resolve, reject) => {
        axios.post('/platform/user/signup', {
          address: json.address,
          adressNumber: json.addressNumber,
          cellphone: json.phone.trim(),
          city: {
            id: json.city
          },
          email: json.email.toLowerCase(),
          emailReceiverAccepted: json.isEmailReceiverAccepted,
          name: json.name,
          password: json.password,
          phone: json.phone.trim(),
          physicalPerson: json.amIPhysicalPerson,
          privacyPolicyAccepted: json.isPrivacyPolicyAccepted,
          type: json.type
        })
          .then(res => {
            Loading.hide()
            Notify.create({
              message: i18n.t('Registro realizado com sucesso!'),
              position: 'top',
              color: 'positive'
            })
            dispatch('firstLogin', login)
            resolve()
          })
          .catch(err => {
            reject(err)
            Loading.hide()
            Notify.create({
              message: 'Ocorreu um erro no seu registro, por favor, contate nosso suporte!',
              position: 'top'
            })
          })
      })
    },
    sendEmailVerify ({ dispatch }, email) {
      Loading.show({ spinner: QSpinnerTail, spinnerSize: 80, spinnerColor: 'blue' })
      axios.post('/platform/user/sendEmailVerifier', {
        content: '<div>Acesse o link para validar seu email: ' +
         '<a href="https://www.multicargo.io/verificarConta/$code">multicargo-link</a>' +
         '<br><br>Atenciosamente, equipe Multicargo</div>',
        subject: 'Verificação de conta - Multicargo',
        type: 'HTML'
      })
        .then(res => {
          Notify.create({
            message: 'Foi enviado um e-mail de verificação da conta, acesse e ative as vantagens do Multicargo! ',
            position: 'top',
            color: 'positive'
          })
          Loading.hide()
        })
        .catch(err => {
          console.log(err)
          Notify.create({
            message: 'Houve um erro ao enviar o e-mail de verificação, tente novamente por favor!',
            position: 'top',
            color: 'negative'
          })
          Loading.hide()
        })
    },
    verifyEmail ({ dispatch }, code) {
      axios.post(`platform/user/validEmail/${code}`)
        .then(res => {
          Notify.create({
            message: 'Conta verificada com sucesso!',
            position: 'top',
            type: 'positive'
          })
        })
        .catch(err => {
          Notify.create({
            message: 'Código inválido',
            position: 'top',
            type: 'negative'
          })
          console.log(err)
        })
    },
    requestPermission ({ dispatch }, id) {
      axios.post(`/platform/company/request/${id}`)
        .then(res => {
          Notify.create({
            message: i18n.t('Pedido de associação enviado, aguarde a liberação pelo usuário dono da empresa!'),
            position: 'top',
            color: 'positive'
          })
        })
        .catch(err => {
          console.log(err)
          Notify.create({
            message: i18n.t('Você já solicitou uma associação, por favor, aguarde a liberação'),
            position: 'top'
          })
        })
    },
    getUser ({ commit }, token) {
      axios.defaults.headers.common['Token'] = token
      axios.get('/platform/user')
        .then(res => {
          commit('saveUserInfo', res.data)
        })
        .catch(err => {
          console.log(err)
        })
    },
    logout () {
      axios.defaults.headers.common['Token'] = ''
      window.localStorage.clear()
      router.push('/sign')
    },
    getUserInfo ({ commit }) {
      axios.get('/platform/user', { headers: { Token: window.localStorage.getItem('userToken') } })
        .then(res => {
          commit('saveUserInfo', res.data)
        })
        .catch(err => {
          console.log(err.response)
        })
    },
    changeUserInfo ({ commit }, data) {
      axios.put('/platform/user', data)
        .then(res => {
          commit('saveUserInfo', res.data)
          window.localStorage.setItem('userToken', res.data.token)
          axios.defaults.headers.common['Token'] = res.data.token
          Notify.create({
            message: 'Informações alteradas com sucesso',
            position: 'top',
            color: 'positive'
          })
        })
        .catch(err => {
          console.log(err.response)
          Notify.create({
            message: 'Não foi possível alterar as informações',
            position: 'top',
            color: 'negative'
          })
        })
    },
    putUser ({ dispatch }, user) {
      user.cellphone = user.cellphone.trim()
      axios.put('/platform/user', user)
        .then(res => {
          Notify.create({
            message: 'Informações alteradas com sucesso',
            position: 'top',
            color: 'positive'
          })
        })
        .catch(err => {
          console.log(err)
          Notify.create({
            message: 'Não foi possível alterar as informações',
            position: 'top',
            color: 'negative'
          })
        })
    }
  },
  mutations: {
    saveUserToken (state, payload) {
      state.userToken = payload
    },
    saveUserImages (state, payload) {
      state.images = payload
    },
    saveUserInfo (state, payload) {
      state.userData = payload
    }
  },
  getters: {
    userImages: state => {
      let response = []
      let arrayUpdate = []
      let count = 0

      state.updatesList.forEach(e => {
        if (count < 4) {
          count++
        } else {
          response.push(arrayUpdate)
          count = 0
          arrayUpdate = []
        }
        arrayUpdate.push(e)
      })
      response.push(arrayUpdate)
      return response
    },
    userName: state => {
      if (state.userData.name !== undefined) {
        return state.userData.name.split(' ')[0]
      }
      return ''
    },
    userData: state => {
      return state.userData
    }
  }
}
